
export var CompanyData = {
    phoneNumber:"416-918-8226",
    area:"Toronto to Niagara Falls ON, Canada and Surrounding Area",
    email:"michael@aquaticedge.ca",
    facebookUrl:"https://www.facebook.com/aquaticedge.ca",
    instagramUrl:"https://www.instagram.com/aquaticedge.ca",
}